var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("All Contacts "),_c('span',[_vm._v("("+_vm._s(_vm._f("prettyNumber")(_vm.count))+")")])]),_c('div',{staticClass:"sub-text"},[_vm._v("All contacts")]),_c('DataTable',{attrs:{"filter":'all',"count":_vm.count}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }